import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      light: '#F2FFE9',
      main: '#557C55',
      dark: '#406343',
      contrastText: '#ffffff',
    }
  }
});